import * as React from 'react';
import { List } from 'semantic-ui-react';
import { TrackSegmentKind } from '../../../types/fallbackTrackingTypes';
import { OVERLAP_NOTE, SEGMENT_STYLES } from './fallbackTrackingStyles';

const KINDS: TrackSegmentKind[] = ['Real', 'Synthetic', 'NoData'];

const FallbackTrackingLegend: React.FC = () => (
    <List className="fallback-tracking-legend">
        {KINDS.map(kind => {
            const { label, description, strokeColor, strokeThickness, strokeOpacity } = SEGMENT_STYLES[kind];
            return (
                <List.Item key={kind}>
                    <span className="legend-line" style={{ borderTopColor: strokeColor, borderTopWidth: strokeThickness, opacity: strokeOpacity }} />
                    <span><strong>{label}:</strong> {description}</span>
                </List.Item>
            );
        })}
        <List.Item className="legend-note">{OVERLAP_NOTE}</List.Item>
    </List>
);

export default FallbackTrackingLegend;
